import { Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebookF, FaYoutube, FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
import { Helmet } from "react-helmet";
import "./styles.scss";

import BannerBg from "./img/BANNER_BG.png";
import HeroImage from "./img/MENS_CACADORES.png";
import PetLogo from "./img/Pet.png";
import GamesLogo from "./img/Games.png";
import FerramentasLogo from "./img/Ferramentas.png";
import TvsLogo from "./img/TVs.png";
import GeralLogo from "./img/GeralC.png";
import PerfumesLogo from "./img/logo.png";

const baseURL = process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_MERCADIM_BASE_URL_PRO
    : process.env.REACT_APP_MERCADIM_BASE_URL_DEV;

const categories = [
    { slug: "pet", nome: "Pet", logo: PetLogo, link: "/grupos/pet" },
    { slug: "games", nome: "Games", logo: GamesLogo, link: "/grupos/games" },
    { slug: "ferramentas", nome: "Ferramentas", logo: FerramentasLogo, link: "/grupos/ferramentas" },
    { slug: "tvs", nome: "TV's", logo: TvsLogo, link: "/grupos/tvs" },
    { slug: "perfumes", nome: "Perfumes", logo: PerfumesLogo, link: "/grupos/perfumes" },
    { slug: "ofertas", nome: "Geral!", logo: GeralLogo, link: "/grupos/geral" },
];

export default function Grupos() {
    return (
        <>
            <Helmet title="Grupos de Ofertas - Caçadores de Ofertas" />
            <div className="grupos-page">
                <section
                    className="hero-section"
                    style={{ backgroundImage: `url(${BannerBg})` }}
                >
                    <div className="hero-content">
                        <h1>Entre para os grupos de ofertas dos Caçadores!</h1>
                        <p>
                            Criamos canais no WhatsApp e Telegram para divulgar produtos em
                            promoção de fontes confiáveis; compartilhe a página com amigos para
                            economizar.
                        </p>
                        <div className="hero-ctas">
                            <a
                                href={`${baseURL}entrar?tipo=ofertas`}
                                target="_blank"
                                rel="noreferrer"
                                className="hero-btn hero-btn-whatsapp"
                            >
                                <FaWhatsapp /> Entrar no WhatsApp
                            </a>
                            <a
                                href="https://t.me/s/cacadoresofertas"
                                target="_blank"
                                rel="noreferrer"
                                className="hero-btn hero-btn-telegram"
                            >
                                <FaTelegramPlane /> Entrar no Telegram
                            </a>
                        </div>
                    </div>
                    <div className="hero-image">
                        <Image src={HeroImage} alt="Caçadores de Ofertas" />
                    </div>
                </section>

                <section className="nichos-section">
                    <h2>Grupos nichados!</h2>
                    <p className="nichos-subtitle">
                        Participe do grupo de ofertas exclusivo para a marca do seu próximo celular!
                    </p>

                    <div className="category-grid">
                        {categories.map((cat) => (
                            <div key={cat.slug} className="category-item">
                                <div
                                    className="category-card"
                                    style={
                                        cat.slug === "perfumes"
                                            ? { backgroundColor: "#0B4EA2" }
                                            : undefined
                                    }
                                >
                                    <img src={cat.logo} alt={cat.nome} />
                                </div>
                                <p className="category-name">{cat.nome}</p>
                                <Link to={cat.link} className="entrar-btn">Entrar</Link>
                            </div>
                        ))}
                    </div>
                </section>

                <footer className="footer">
                    <div className="footer-left">
                        <h3>Quem somos</h3>
                        <Link to="/entrar" className="footer-link">Entrar</Link>
                        <Link to="/sobre" className="footer-link">Sobre</Link>
                    </div>
                    <div className="footer-right">
                        <h3>Contato</h3>
                        <p className="footer-email">cacadoresdeofertas1@gmail.com</p>
                        <div className="footer-social-links">
                            <a href="https://instagram.com/cacadores.ofertas" aria-label="Instagram" target="_blank" rel="noreferrer">
                                <FaInstagram />
                            </a>
                            <a href="https://www.facebook.com/people/Ca%C3%A7adores-de-Ofertas/100093225681424/" aria-label="Facebook" target="_blank" rel="noreferrer">
                                <FaFacebookF />
                            </a>
                            <a href="https://www.youtube.com/@cacadoresofertas" aria-label="YouTube" target="_blank" rel="noreferrer">
                                <FaYoutube />
                            </a>
                            <a href={`${baseURL}entrar?tipo=ofertas`} aria-label="WhatsApp" target="_blank" rel="noreferrer">
                                <FaWhatsapp />
                            </a>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}
